import { render, staticRenderFns } from "./vistaReactivos.vue?vue&type=template&id=47cddf56&scoped=true&"
import script from "./vistaReactivos.vue?vue&type=script&lang=js&"
export * from "./vistaReactivos.vue?vue&type=script&lang=js&"
import style0 from "./vistaReactivos.vue?vue&type=style&index=0&id=47cddf56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cddf56",
  null
  
)

export default component.exports